export const Family = 
{
    Metadata:{Name:'Family',maxColumn:9,numRows:13},
    Sections:
    [
        {
            Headers:[
                "Have you or an immediate family member been diagnosed or suspected of having the " +
                "following? Please check all appropriate boxes. " +
                "<span class='importantText'>Questions reference biological family members.</span>",
                "Father",
                "Mother",
                "Brother",
                "Sister",
                "Grandfather",
                "Grandmother",
                "Son",
                "Daughter",
                "Self"
            ],
            Questions:[
                {
                    Prompt:"Bipolar, Hypomania or Manic-depressive disorder",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"ADHD, ADD (Attention deficit or hyperactivity)",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Schizophrenia or other psychosis",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Autism Spectrum",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Depression",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Anxiety",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Thoughts of suicide",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Suicide attempts",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Thoughts of homicide",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Homicide attempts",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Excessive/problematic alcohol use",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Substance/drug abuse",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
                {
                    Prompt:"Trauma",
                    Responses:[
                        {Value:"father",Type:"checkbox"},
                        {Value:"mother",Type:"checkbox"},
                        {Value:"brother",Type:"checkbox"},
                        {Value:"sister",Type:"checkbox"},
                        {Value:"grandfather",Type:"checkbox"},
                        {Value:"grandmother",Type:"checkbox"},
                        {Value:"son",Type:"checkbox"},
                        {Value:"daughter",Type:"checkbox"},
                        {Value:"self",Type:"checkbox"},
                    ]
                },
            ]
        }
    ]
}